import { connect } from 'react-redux';
import { Dispatch } from 'redux';

import { IState } from '../../store';
import { IOfferRefusedDispatchProps, IOfferRefusedProps, OfferRefused } from './';
import { openModal } from '../../store/popups/reclaim';

export const mapStateToProps = (state: IState): IOfferRefusedProps => ({
  isImported: state.offerData.offer.isImported,
  isOpenModalReclaim: state.reclaimModal.isOpen,
  newEdit: state.offerData.offer.newEdit,
  offences: state.offerData.offences,
  offerUserId: state.offerData.offer.userId,
  publishedUserId: state.offerData.offer.publishedUserId,
  status: state.offerData.offer.status,
  statusFetchModalReclaim: state.reclaimModal.statusFetch,
  userId: state.offerData.user && state.offerData.user.realtyUserId,
  userConfirmedFix: state.offerData.offer.userConfirmedFix,
});

export const mapDispatchToProps = (dispatch: Dispatch<IState>): IOfferRefusedDispatchProps => ({
  openReclaimModal: () => {
    dispatch(openModal());
  },
});

export const OfferRefusedContainer = connect<IOfferRefusedProps, IOfferRefusedDispatchProps, {}>(
  mapStateToProps,
  mapDispatchToProps,
)(OfferRefused);
